import store from '@/store'
import { hasExpirationTimestamp } from '@/utils/tokenUtil'

const landingGuard = async (to, from, next) => {
  // Durante el prerender no hay sesión ni API; renderizar el landing directo
  if (typeof window !== 'undefined'
      && window.__PRERENDER_INJECTED
      && window.__PRERENDER_INJECTED.isPrerender) {
    return next()
  }

  const loggedUser = store.getters['auth/getLoggedUser']
  const isExpired = store.getters['auth/isExpired']

  // 1. Si no hay usuario, intentar restaurar sesión
  if (!loggedUser) {
    const justLoggedOut = sessionStorage.getItem('justLoggedOut')
    
    if (justLoggedOut) {
      sessionStorage.removeItem('justLoggedOut')
      next()
      return
    }

    try {
      const { data, error } = await store.dispatch('auth/getSession')
      if (!error && data?.user) {
        const expires_in = data.expires_in || data.data?.expires_in
        const redirectUrl = data.user.route_name_redirect?.domain

        if (redirectUrl) {
          window.location.href = `${redirectUrl}/verify-token/authenticate/${expires_in}`
          return
        }
      }
    } catch (error) {
      console.error(error)
    }
    
    if (hasExpirationTimestamp()) {
      store.commit('auth/logout')
    }
    next()
    return
  }

  // 2. Si hay usuario pero está expirado, intentar refrescar
  if (isExpired) {
    const { error } = await store.dispatch('auth/refreshToken')
    if (error) {
      store.commit('auth/logout')
      next()
      return
    }
  }

  // 3. Usuario válido (o refrescado): redirigir a su home
  let routeName = ''
  switch (loggedUser.role_id) {
    case 1:
      routeName = 'psycologists-home-index'
      break
    case 2:
      routeName = 'waiting-room-index'
      break
    case 3:
      routeName = 'interviewer-index'
      break
    case 4:
      routeName = 'users-index'
      break
  }
  next({ name: routeName })
}

export default landingGuard
